import type { LanguageResource } from "@ruter-as/web-components-and-tools";

interface ZoneLanguageResource {
	to: string;
	from: string;
}

const zoneLanguageResource: LanguageResource<ZoneLanguageResource> = {
	nb: {
		from: "Fra sone",
		to: "Til sone",
	},
};

export default zoneLanguageResource;
